















import Vue from 'vue';

export default Vue.extend({
  name: 'BarMetricCard',
  props: {
    header: {
      type: String,
      required: true,
    },
    subheader: {
      type: String,
    },
    metricPercent: {
      type: Number,
      required: true,
    },
    label: {
      type: String,
      required: false,
    },
    color: {
      type: String,
      required: true,
    },
    bgColor: {
      type: String,
      required: true,
    },
  },
});
